import React, { useState } from "react";
import CustomSlider from "../section/CustomSlider";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast, ToastContainer } from "react-toastify";  // Import Toastify components
import "react-toastify/dist/ReactToastify.css";  // Import Toastify CSS

export default function SignuUpStudent() {
    const { t } = useTranslation();
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [email, setEmail] = useState("");
    const [gender, setGender] = useState("");
    const [ageGroup, setAgeGroup] = useState("");
    const [schoolType, setSchoolType] = useState("");
    const [placeOfResidence, setPlaceOfResidence] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const handleSignUpSubmit = (e) => {
        e.preventDefault();
        
        if (password !== confirmPassword) {
            alert("Passwords do not match.");
        } else {
            toast.success(t("Sign Up Successful"), {
                position: "top-left",  
                autoClose: 2000,  
            });
        }
    };

    return (
        <>
            <ToastContainer />

            <section className="relative h-[100vh]">
                <div className="container h-full flex justify-between items-center">
                    <div className="w-[45%] flex flex-col gap-[40px]">
                        <div>
                            <img className="w-[150px]" src={require("../../assets/logo/logo.svg").default} alt="" />
                        </div>
                        <div className="flex flex-col text-[#09778E] font-bold text-[30px]">
                            <div>{t("Welcome to Academicx")}</div>
                            <div>{t("Learning Platform as a Student")}</div>
                        </div>
                        <div>
                            <CustomSlider />
                        </div>
                    </div>
                    <div className="w-[5%]">
                        <img className="h-[650px]" src={require("../../assets/icons/rigister-line.svg").default} alt="" />
                    </div>
                    <div className="w-[45%] flex flex-col justify-between gap-[50px]">
                        <div className="flex items-center text-center flex-col gap-[8px] justify-center">
                            <div className="flex flex-col text-[#09778E] font-bold text-[30px] capitalize">{t("fill in the fields to create your account")}</div>
                            <div className="flex items-center gap-[12px]">
                                <span className="w-[30px] h-[2px] bg-[#5D5A6F] flex rounded-full"></span>
                                <div className="text-[#5D5A6F] flex items-center gap-[5px]">
                                    {t("Do you have an account ?")}<Link to={"/login"} className="text-[#09758b]">{t("Login Now")}</Link>
                                </div>
                                <span className="w-[30px] h-[2px] bg-[#5D5A6F] flex rounded-full"></span>
                            </div>
                        </div>
                        <form onSubmit={handleSignUpSubmit}>
                            <div className="flex flex-col gap-[8px]">
                                <div className="flex items-center gap-[25px]">
                                    <div className="w-[50%] flex flex-col gap-[5px]">
                                        <label className="text-[#09778E] font-bold">{t("First Name")}</label>
                                        <input type="text" className="p-3 rounded-md bg-white border-2 border-[#09778e] outline-none" placeholder={t("Your First Name")} value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                                    </div>
                                    <div className="w-[50%] flex flex-col gap-[5px]">
                                        <label className="text-[#09778E] font-bold">{t("Last Name")}</label>
                                        <input type="text" className="p-3 rounded-md bg-white border-2 border-[#09778e] outline-none" placeholder={t("Your Last Name")} value={lastName} onChange={(e) => setLastName(e.target.value)} />
                                    </div>
                                </div>
                                <div className="flex items-center gap-[25px]">
                                    <div className="w-[50%] flex flex-col gap-[5px]">
                                        <label className="text-[#09778E] font-bold">{t("Phone Number")}</label>
                                        <input type="text" className="p-3 rounded-md bg-white border-2 border-[#09778e] outline-none" placeholder={t("Your Phone Number")} value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} />
                                    </div>
                                    <div className="w-[50%] flex flex-col gap-[5px]">
                                        <label className="text-[#09778E] font-bold">{t("Your Email")}</label>
                                        <input type="email" className="p-3 rounded-md bg-white border-2 border-[#09778e] outline-none" placeholder={t("Your Email")} value={email} onChange={(e) => setEmail(e.target.value)} />
                                    </div>
                                </div>
                                <div className="flex items-center gap-[25px]">
                                    <div className="w-[50%] flex flex-col gap-[5px]">
                                        <label className="text-[#09778E] font-bold">{t("Gender")}</label>
                                        <select className="p-3 rounded-md bg-white border-2 border-[#09778e] outline-none" value={gender} onChange={(e) => setGender(e.target.value)}>
                                            <option value="">{t("Your Gender")}</option>
                                            <option value="male">{t("Male")}</option>
                                            <option value="female">{t("Female")}</option>
                                            <option value="other">{t("Other")}</option>
                                        </select>
                                    </div>
                                    <div className="w-[50%] flex flex-col gap-[5px]">
                                        <label className="text-[#09778E] font-bold">{t("Age Group")}</label>
                                        <select className="p-3 rounded-md bg-white border-2 border-[#09778e] outline-none" value={ageGroup} onChange={(e) => setAgeGroup(e.target.value)}>
                                            <option value="">{t("Age Group")}</option>
                                            <option value="child">{t("Child")}</option>
                                            <option value="teen">{t("Teen")}</option>
                                            <option value="adult">{t("Adult")}</option>
                                            <option value="senior">{t("Senior")}</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="flex items-center gap-[25px]">
                                    <div className="w-[50%] flex flex-col gap-[5px]">
                                        <label className="text-[#09778E] font-bold">{t("School Type")}</label>
                                        <select className="p-3 rounded-md bg-white border-2 border-[#09778e] outline-none" value={schoolType} onChange={(e) => setSchoolType(e.target.value)}>
                                            <option value="">{t("School Type")}</option>
                                            <option value="child">{t("Child")}</option>
                                            <option value="teen">{t("Teen")}</option>
                                            <option value="adult">{t("Adult")}</option>
                                            <option value="senior">{t("Senior")}</option>
                                        </select>
                                    </div>
                                    <div className="w-[50%] flex flex-col gap-[5px]">
                                        <label className="text-[#09778E] font-bold">{t("Place of Residence")}</label>
                                        <input type="text" className="p-3 rounded-md bg-white border-2 border-[#09778e] outline-none" placeholder={t("Your Place of Residence")} value={placeOfResidence} onChange={(e) => setPlaceOfResidence(e.target.value)} />
                                    </div>
                                </div>
                                <div className="flex items-center gap-[25px]">
                                    <div className="w-[50%] flex flex-col gap-[5px]">
                                        <label className="text-[#09778E] font-bold">{t("Password")}</label>
                                        <input type="password" className="p-3 rounded-md bg-white border-2 border-[#09778e] outline-none" placeholder={t("Your Password")} value={password} onChange={(e) => setPassword(e.target.value)} />
                                    </div>
                                    <div className="w-[50%] flex flex-col gap-[5px]">
                                        <label className="text-[#09778E] font-bold">{t("Confirm Password")}</label>
                                        <input type="password" className="p-3 rounded-md bg-white border-2 border-[#09778e] outline-none" placeholder={t("Confirm Password")} value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
                                    </div>
                                </div>
                                <button className="bg-[#A31D1C] p-3 font-bold text-white capitalize rounded-md" type="submit">{t("Sign Up")}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
        </>
    );
}
